import vue from "vue";
import { initialState } from "./initialState";
export default {
    SET_OLD_RECEPTIONS_REFERRALS: (state, oldReceptionsReferrals) => {
        state.oldReceptionsReferrals = oldReceptionsReferrals;
    },
    SET_OLD_RECEPTIONS_CONSULATES: (state, oldReceptionsConsulates) => {
        state.oldReceptionsConsulates = oldReceptionsConsulates;
    },
    SET_RECEPTIONS: (state, receptions) => {
        state.receptions = _.cloneDeep(receptions);
    },
    SET_NOW_TIME: (state, nowTime) => {
        state.nowTime = nowTime;
    },
    SET_RECEPTION_TYPES: (state, receptionTypes) => {
        state.receptionTypes = receptionTypes;
    },
    SET_RECEPTION_TO_MANAGE: (state, receptionToManage) => {
        state.receptionToManage = receptionToManage;
    },
    SET_USER_TO_MANAGE: (state, userToManage) => {
        state.userToManage = userToManage;
    },
    SET_RECEPTIONS_TO_CREATE: (state, receptionsToCreate) => {
        state.receptionsToCreate = receptionsToCreate;
    },
    SET_USERS_LIST: (state, usersList) => {
        state.usersList = usersList;
    },
    SET_DISCOUNTS_LIST: (state, discountsList) => {
        state.discountsList = discountsList;
    },
    SET_RECEPTION_SERVICES: (state, services) => {
        state.receptionServices = services;
    },
    RESET_MODULE (state) { // To reset the entire module
        Object.assign(state, JSON.parse(JSON.stringify(_.cloneDeep(initialState))))
        // Object.assign(state, JSON.parse(JSON.stringify(initialState)))
    },
    RESET_MODULE_RECEPTIONS_TO_CREATE (state) { // To reset the entire module
        // state.receptionsToCreate = JSON.parse(JSON.stringify(initialState.receptionsToCreate))
        Object.assign(state.receptionsToCreate, JSON.parse(JSON.stringify(_.cloneDeep(initialState.receptionsToCreate))))
    },
    SET_DONE_RECEPTIONS: (state, doneReceptions) => {
        state.doneReceptions = doneReceptions;
    },
    SET_NOCHARGE: (state, noCharge) => {
        state.noCharge = noCharge;
    },
    SET_REPEAT: (state, repeat) => {
        state.repeat = repeat;
    },
    SET_DESCRIPTION: (state, description) => {
        state.description = description;
    },
    SET_RECEPTION_TO_PAY_FOR_SERVICES: (state, receptionToPayForServices) => {
        state.receptionToPayForServices = receptionToPayForServices;
    },
    SET_RECEPTION_TO_PAY_FOR: (state, receptionToPayFor) => {
        state.receptionToPayFor = receptionToPayFor;
    },
    SET_PATIENT_PAYMENT: (state, patientPayment) => {
        state.patientPayment = patientPayment;
    },
    SET_EXCESS_PAYMENT: (state, excessPayment) => {
        state.excessPayment = excessPayment;
    },
    SET_CURRENT_EXCESS_PAYMENT: (state, currentExcessPayment) => {
        state.currentExcessPayment = currentExcessPayment;
    },
    SET_SERVICE_RETURN: (state, serviceReturn) => {
        state.serviceReturn = serviceReturn;
    },
    SET_CURRENT_SERVICE_RETURNS: (state, currentServiceReturns) => {
        state.currentServiceReturns = currentServiceReturns;
    },
    RESET_SERVICE_RETURN: (state) => {
        state.serviceReturn = JSON.parse(JSON.stringify(_.cloneDeep(initialState.serviceReturn)));
        state.excessPayment = JSON.parse(JSON.stringify(_.cloneDeep(initialState.excessPayment)));
        state.currentExcessPayment = JSON.parse(JSON.stringify(_.cloneDeep(initialState.currentExcessPayment)));
        state.currentServiceReturns = JSON.parse(JSON.stringify(_.cloneDeep(initialState.currentServiceReturns)));
    },
    SET_ALL_PAYMENTS: (state, allPayments) => {
        state.allPayments = allPayments;
    },
    SET_RECEPTION_SERVICES_ROWS: (state, receptionServicesRows) => {
        state.receptionServicesRows = receptionServicesRows;
    },
    SET_VISIT_SERVICES:(state,visitServices)=>{
        state.visitServices = visitServices;
    },
    // SET_CREATED_RECEPTION_ID_FOR_ADD_VISIT:(state,createdReceptionIdForAddVisit)=>{
    //     state.createdReceptionIdForAddVisit = createdReceptionIdForAddVisit;
    // },
    SET_CREATED_VISIT_SERVICE:(state,createdVisitService)=>{
        state.createdVisitService = createdVisitService;
    },
    SET_CREATED_RECEPTION:(state,createdReception)=>{
        state.createdReception = createdReception;
    },
    SET_USERS_FOR_VISIT:(state, usersForVisit)=>{
        state.usersForVisit = usersForVisit;
    },
    SET_DISCOUNTS_FOR_VISIT:(state, discountsForVisit)=>{
        state.discountsForVisit = discountsForVisit;
    },
    SET_ADDED_VISIT_SERVICE:(state, addedVisitService)=>{
        state.addedVisitService = addedVisitService;
    },
    SET_DONE_RECEPTIONS_FOR_THIS_ROOM:(state, doneReceptionsForThisRoom)=>{
        // state.doneReceptionsForThisRoom = doneReceptionsForThisRoom;
        vue.set(state, 'doneReceptionsForThisRoom', doneReceptionsForThisRoom)
    },
    SET_DOCTORS:(state, doctors)=>{
        state.doctors = doctors;
    },
    SET_INSURANCES:(state, insurances)=>{
        state.insurances = insurances;
    },
    SET_CURRENT_DAY_RECEPTIONS:(state, currentDayReceptions)=>{
        state.currentDayReceptions = currentDayReceptions;
    },
    SET_CURRENT_DAY_RECEPTION_SEARCH:(state, currentDayReceptionSearch)=>{
        state.currentDayReceptionSearch = currentDayReceptionSearch;
    },
    SET_PAYMENT_TO_EDIT:(state, paymentToEdit)=>{
        state.paymentToEdit = paymentToEdit;
    },

    RESET_MODULE_VISIT(state) {
        state.visitServices = JSON.parse(JSON.stringify(initialState.visitServices));
        state.receptionsToCreate = JSON.parse(JSON.stringify(initialState.receptionsToCreate));
        state.createdReception = JSON.parse(JSON.stringify(initialState.createdReception));
        state.createdVisitService = JSON.parse(JSON.stringify(initialState.createdVisitService));
        state.usersForVisit = JSON.parse(JSON.stringify(initialState.usersForVisit));
        state.discountsForVisit = JSON.parse(JSON.stringify(initialState.discountsForVisit));
        // state.addedVisitService = JSON.parse(JSON.stringify(initialState.addedVisitService));
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
    SET_CALLING_DOCTORS: (state, callingDoctors) =>{
        vue.set(state.receptionToManage, 'callingDoctors', callingDoctors)
    },
}
